"use client"

import React from 'react'

interface AuthLayoutProps {
  children: React.ReactNode
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="h-screen flex flex-col lg:flex-row overflow-hidden">
      {/* Left side - Space background with text (hidden on mobile) */}
      <div
        className="hidden lg:flex lg:flex-1 relative bg-cover bg-center bg-no-repeat items-end"
        style={{
          backgroundImage: `url('https://res.cloudinary.com/dlwegkhme/image/upload/v1758276306/4566fdb7d627725b2d38f7ee63b5325d353e3957_dfuanb.png')`
        }}
      >
        <div className="relative z-10 p-12 pb-16">
          <div className="backdrop-blur-md bg-[#6F67670F] rounded-xl p-12 max-w-sm">
            <h1 className="text-white text-xl font-medium font-satoshi">
              Harnessing Space Technology for Africa's Sustainable Development
            </h1>
          </div>
        </div>
      </div>

      {/* Right side - Auth forms */}
      <div className="flex-1 bg-[#F9F9F9] flex items-center justify-center p-4 sm:p-8 overflow-hidden">
        <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-4 sm:p-8 my-auto">
          {/* Top decorative frame */}
          <div className="mb-6 sm:mb-8 -mx-4 sm:-mx-8 -mt-4 sm:-mt-8">
            <img
              src="/top-frame.png"
              alt=""
              className="w-full h-auto object-cover rounded-t-lg"
            />
          </div>

          {/* AFSA Logo */}
          <div className="text-center mb-6 sm:mb-8">
            <img
              className="h-12 sm:h-16 w-auto mx-auto"
              src='https://res.cloudinary.com/dlwegkhme/image/upload/v1755760984/LOGO_AFSA_o4r8px.png'
              alt="AFSA logo"
            />
          </div>

          {/* Auth form content */}
          {children}

          {/* Bottom decorative frame */}
          <div className="mt-6 sm:mt-8 -mx-4 sm:-mx-8 -mb-4 sm:-mb-8">
            <img
              src="/buttom-frame.png"
              alt=""
              className="w-full h-auto object-cover rounded-b-lg"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthLayout